import { lazy, Suspense } from "react";
import CircularLoader from "../custom/circularLoader/circularLoader";

const Main = lazy(() => import("../components/signIn/main"));



const SignIn = () => {
    return (
        <Suspense fallback={<CircularLoader />}>
            <Main />
        </Suspense>
    )
}
export default SignIn